import dayjs from "dayjs";
import { FIELD_TYPES } from "@hyro-components/fields/utils";

const useFilterItem = ({ value, type, label }) => {
  const hasValue = value && value.length > 0;

  const getDisplayValue = () => {
    if (!value) return "";

    if (type === FIELD_TYPES.DATE && Array.isArray(value) && value.length === 2) {
      const startDate = dayjs(value[0]);
      const endDate = dayjs(value[1]);
      if (startDate.isValid() && endDate.isValid()) {
        const isSameDate = startDate.format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD");
        const isSameTime = startDate.format("HH:mm") === endDate.format("HH:mm");

        if (isSameDate && isSameTime) {
          return startDate.format("MMM D, h:mm A");
        }

        if (isSameDate) {
          return `${startDate.format("MMM D, h:mm A")} – ${endDate.format("h:mm A")}`;
        }

        if (isSameTime) {
          return `${startDate.format("MMM D, h:mm A")} – ${endDate.format("MMM D, h:mm A")}`;
        }

        return `${startDate.format("MMM D, h:mm A")} – ${endDate.format("MMM D, h:mm A")}`;
      }
      return "";
    }

    if (Array.isArray(value) && value.length === 1) {
      return typeof value[0] === "string" ? value[0] : value[0].display_key;
    }

    return value.length;
  };

  const getTooltipText = () => {
    if (!value) return undefined;

    if (type === FIELD_TYPES.DATE && Array.isArray(value) && value.length === 2) {
      const startDate = dayjs(value[0]);
      const endDate = dayjs(value[1]);
      if (startDate.isValid() && endDate.isValid()) {
        const isSameDate = startDate.format("YYYY-MM-DD") === endDate.format("YYYY-MM-DD");
        const isSameTime = startDate.format("HH:mm") === endDate.format("HH:mm");

        if (isSameDate && isSameTime) {
          return `${label}: ${startDate.format("MMMM D, YYYY")} at ${startDate.format("h:mm A")}`;
        }

        if (isSameDate) {
          return `${label}: ${startDate.format("MMMM D, YYYY")} at ${startDate.format("h:mm")} - ${endDate.format("h:mm A")}`;
        }

        return `${label}: ${startDate.format("MMMM D, YYYY")} at ${startDate.format("h:mm")} - ${endDate.format("MMMM D, YYYY")} at ${endDate.format("h:mm A")}`;
      }
      return undefined;
    }

    return hasValue ? `${label}: ${getDisplayValue()}` : undefined;
  };

  return {
    displayValue: getDisplayValue(),
    tooltipText: getTooltipText(),
    hasValue
  };
};

export default useFilterItem;

